import { isValidPhoneNumber } from "react-phone-number-input";
import { z } from "zod";
import { SchemaErrorMessage } from "./translation";

export const phoneSchema = z
  .string()
  .min(1, { message: SchemaErrorMessage.PhoneRequired })
  .refine((val) => isValidPhoneNumber(val), {
    message: SchemaErrorMessage.PhoneInvalid,
  });
export const phoneSchemaOptionnal = z
  .string()
  .refine((val) => (val === "" || val === undefined ? true : isValidPhoneNumber(val)), {
    message: SchemaErrorMessage.PhoneInvalid,
  })
  .optional();

export const emailSchema = z.union([z.literal(""), z.string().email()]);

export const preferredLanguageSchema = z.enum(["en", "fr"], {
  message: SchemaErrorMessage.PreferredLanguageRequired,
});
